import { agentsApi } from '../../../data/agentsApi';
import type { AgentCatalogItemView } from './catalogViews';

/**
 * Catalog feature endpoints, injected into the single agents base api.
 *
 * Owns the agent catalog list only. The agent detail header lives in the detail feature; the agent
 * definition / health reads are shared (module `data/sharedEndpoints.ts`).
 */
export const catalogEndpoints = agentsApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgents: builder.query<AgentCatalogItemView[], { company?: string }>({
      query: ({ company }) => ({
        url: '/agents',
        method: 'GET',
        params: company ? { company } : undefined,
      }),
      providesTags: ['AgentCatalog'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAgentsQuery } = catalogEndpoints;
